import { render, staticRenderFns } from "./myRegistration.vue?vue&type=template&id=2a4bed44&scoped=true"
import script from "./myRegistration.vue?vue&type=script&lang=js"
export * from "./myRegistration.vue?vue&type=script&lang=js"
import style0 from "./myRegistration.vue?vue&type=style&index=0&id=2a4bed44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bed44",
  null
  
)

export default component.exports